import * as Types from '../../../generated/graphql';

import { gql } from '@apollo/client';
import { SensorRowFragmentDoc } from '../../../graphql/Sensor.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SensorsQueryVariables = Types.Exact<{
  order?: Types.InputMaybe<Types.SensorFilter_Order>;
  search?: Types.InputMaybe<Types.Scalars['String']>;
  favorite?: Types.InputMaybe<Types.Scalars['Boolean']>;
  pageSize: Types.Scalars['Int'];
  after?: Types.InputMaybe<Types.Scalars['String']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  sensorGroups?: Types.InputMaybe<Types.Scalars['String']>;
  approved?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type SensorsQuery = { __typename?: 'Query', sensors?: { __typename?: 'SensorCursorConnection', totalCount: number, pageInfo: { __typename?: 'SensorPageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges?: Array<{ __typename?: 'SensorEdge', node?: { __typename?: 'Sensor', id: string, deviceName: string, connected: boolean, shouldConnect: boolean, type: string, httpUrl?: string | null, httpsUrl?: string | null, sshUrl?: string | null, favorite: boolean, connectionStatus: string, updateScheduled: boolean, updateDeadline?: string | null, updateName?: string | null, lastConnection?: { __typename?: 'ConnectionLogEntry', timestamp: string } | null, vpnStatus?: { __typename?: 'SensorVpnStatus', publicAddress: string, vpnAddress: string, connectedSince: string } | null, status?: { __typename?: 'SensorStatus', macAddress?: string | null, firmwareVersion?: string | null, modelType?: string | null } | null } | null } | null> | null } | null };


export const SensorsDocument = gql`
    query Sensors($order: SensorFilter_order, $search: String, $favorite: Boolean, $pageSize: Int!, $after: String, $before: String, $sensorGroups: String, $approved: Boolean) {
  sensors(
    sensorGroups: $sensorGroups
    search: $search
    order: [$order]
    favorite: $favorite
    first: $pageSize
    after: $after
    before: $before
    approved: $approved
  ) @connection(key: "sensors", filters: ["search", "pageSize"]) {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    totalCount
    edges {
      node {
        ...SensorRow
      }
    }
  }
}
    ${SensorRowFragmentDoc}`;

/**
 * __useSensorsQuery__
 *
 * To run a query within a React component, call `useSensorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorsQuery({
 *   variables: {
 *      order: // value for 'order'
 *      search: // value for 'search'
 *      favorite: // value for 'favorite'
 *      pageSize: // value for 'pageSize'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      sensorGroups: // value for 'sensorGroups'
 *      approved: // value for 'approved'
 *   },
 * });
 */
export function useSensorsQuery(baseOptions: Apollo.QueryHookOptions<SensorsQuery, SensorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SensorsQuery, SensorsQueryVariables>(SensorsDocument, options);
      }
export function useSensorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorsQuery, SensorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SensorsQuery, SensorsQueryVariables>(SensorsDocument, options);
        }
export type SensorsQueryHookResult = ReturnType<typeof useSensorsQuery>;
export type SensorsLazyQueryHookResult = ReturnType<typeof useSensorsLazyQuery>;
export type SensorsQueryResult = Apollo.QueryResult<SensorsQuery, SensorsQueryVariables>;